import objectPrefix from '../../lib/objectPrefix';

const prefix = objectPrefix();

module.exports = {
    dadFace: {
        type: 'movieclip',
        position: {
            x: '10%',
            y: '5%'
        },
        scale: {
            x: '80%'
        },
        texture: `sprite:/img/partials/portraits-${prefix}.json,portraits/dad`
    },

    dadFrame: {
        texture: `sprite:/img/partials/portraits-${prefix}.json,portraits/frame-dad.png`,
        scale: {
            x: '27%'
        },
        position: {
            x: '47.5%',
            y: '64.5%'
        }
    },

    momFace: {
        type: 'movieclip',
        position: {
            x: '6%',
            y: '5%'
        },
        scale: {
            x: '92%'
        },
        texture: `sprite:/img/partials/portraits-${prefix}.json,portraits/mom`
    },

    momFrame: {
        texture: `sprite:/img/partials/portraits-${prefix}.json,portraits/frame-mom.png`,
        scale: {
            x: '23%'
        },
        position: {
            x: '27.5%',
            y: '4.5%'
        }
    },

    charlesFace: {
        type: 'movieclip',
        position: {
            x: '6%',
            y: '6%'
        },
        scale: {
            x: '92%'
        },
        texture: `sprite:/img/partials/portraits-${prefix}.json,portraits/charles`
    },

    charlesFrame: {
        texture: `sprite:/img/partials/portraits-${prefix}.json,portraits/frame-charles.png`,
        scale: {
            x: '25%'
        },
        position: {
            x: '62%',
            y: '14%'
        }
    },

    agentFace: {
        type: 'movieclip',
        position: {
            x: '4%',
            y: '4%'
        },
        scale: {
            x: '90%'
        },
        texture: `sprite:/img/partials/portraits-${prefix}.json,portraits/agent`
    },

    agentFrame: {
        texture: `sprite:/img/partials/portraits-${prefix}.json,portraits/frame-agent.png`,
        scale: {
            x: '25%'
        },
        position: {
            x: '73%',
            y: '51%'
        }
    },

    ladyFace: {
        type: 'movieclip',
        position: {
            x: '6%',
            y: '6%'
        },
        scale: {
            x: '92%'
        },
        texture: `sprite:/img/partials/portraits-${prefix}.json,portraits/lady`
    },

    ladyFrame: {

        texture: `sprite:/img/partials/portraits-${prefix}.json,portraits/frame-lady.png`,
        scale: {
            x: '24%'
        },
        position: {
            x: '12.5%',
            y: '61%'
        }
    },

    baldGuyFace: {
        type: 'movieclip',
        position: {
            x: '10%',
            y: '3%'
        },
        scale: {
            x: '89%'
        },
        texture: `sprite:/img/partials/portraits-${prefix}.json,portraits/bald-guy`
    },

    baldGuyFrame: {
        texture: `sprite:/img/partials/portraits-${prefix}.json,portraits/frame-bald-guy.png`,
        scale: {
            x: '25%'
        },
        position: {
            x: '0.5%',
            y: '19.5%'
        }
    }
};



// WEBPACK FOOTER //
// ./js/objects/partials/portraits.js